import Aux from "../../../../hoc/Auxiliary/Auxiliary";
import classes from "./Opportunity.module.css";
import {Form} from "react-bootstrap";
import ButtonsStrip from "../../../UI/ButtonsStrip/ButtonsStrip";
import React, {useEffect, useState} from "react";
import _ from "lodash";
import Icon from "../../../UI/Icon/Icon";
import AddClient from "./Client/AddClient";
import {
    createNewClient,
    createNewFile,
    createNewOpportunity,
    updateFileContentByFileId
} from "../../../../graph-services/GraphServices";
import {OpportunityEntity} from "../../../../Entities/OpportunityEntity"
import {translation} from "../../../../I18n/i18n";
import LanguageSelect from "../../CvDetails/languageSelect";
import FormField from "../../../UI/FormField/FormField";

let Element = (props) => {

    let isEditMode = Boolean (props.element)

    // Entities
    let opportunity = OpportunityEntity
    let clientEntity = {
        "name": "",
        "id": "",
    }
    let managerEntity = {
        "displayName": "",
        "email": "",
        "id": "",
    }

    // Initial Fields
    let initialOpportunityName = isEditMode ? props.element.name : ""
    let initialClient = isEditMode ? {
        "name": props.element.details.clientName,
        "id": props.element.details.clientId
    } : clientEntity
    let initialManager = isEditMode ? {
        "displayName": props.element.details.responsible.displayName._text,
        "email": props.element.details.responsible.email._text,
        "id": props.element.details.responsible.id._text
    } : managerEntity
    let initialDeadline = isEditMode ? Object.keys (props.element.details.deadline).length > 0 &&
        props.element.details.deadline._text : "";

    //  State: Fields
    let [opportunityName, setOpportunityName] = useState (initialOpportunityName)
    let [client, setClient] = useState (initialClient)
    let [manager, setManager] = useState (initialManager)
    let [deadline, setDeadline] = useState (initialDeadline)

    let setOpportunity = (opportunityId, creationDate) => {
        opportunity.content.id = opportunityId;
        opportunity.content.name = opportunityName;
        opportunity.content.client = client;
        opportunity.content.deadline = deadline;
        opportunity.content.manager = manager;
        opportunity.content.creationDateTime = creationDate;
    }

    // Handle Popup
    const [popupLauncher, setPopupLauncher] = useState (null);
    const [openPopup, setOpenPopup] = useState (null);

    let launchPopup = (e, v) => {
        setPopupLauncher (e.currentTarget);
        setOpenPopup (v);
    }

    let hidePopup = () => {
        setPopupLauncher (null);
        setOpenPopup (null);
    }

    // Enable / Disable save button by required fields
    let areEmptyRequiredFields = () => {
        return (_.isEqual (opportunityName, "") || _.isEqual (client, clientEntity) || _.isEqual (manager, managerEntity));
    }

    let sleep = (milliseconds) => {
        return new Promise (resolve => setTimeout (resolve, milliseconds))
    }

    // Handle Loading
    let [loading, setLoading] = useState (false);

    useEffect (() => {
        props.onLoading (loading);
    }, [loading])

    // Handle Close
    let hasUnsavedChanges = () => {
        return !(_.isEqual (opportunityName, initialOpportunityName) && _.isEqual (client, initialClient) && _.isEqual (manager, initialManager) && _.isEqual (deadline, initialDeadline))
    }

    let discardChanges = () => {
        hidePopup ();
        props.closeDrawer ();
    }

    let handleCloseDrawer = (e) => {
        hasUnsavedChanges () ?
            launchPopup (e, "Close") : discardChanges ();
    }

    // Handle Save
    let saveOpportunity = () => {
        setLoading (true)
        if (isEditMode) {
            // Edit Opportunity
            // update the opportunity properties file
            setOpportunity (props.element.details.parentId, props.element.details.creationDate)
            updateFileContentByFileId (props.token, props.siteId, props.element.details.id, opportunity)
                .then (r => {
                    if (r.ok) {
                        props.notify (`The opportunity has been updated successfully !`,
                            'success')
                        props.updateOpportunities ()
                        props.reload()
                        sleep (800).then (() => {
                            props.closeDrawer ();
                        })
                    } else if ('error' in r) {
                        props.notify (r.error.message,
                            'error')
                    } else {
                        props.notify (`An error has occurred !`,
                            'error')
                    }
                    setLoading (false);
                })
        } else {
            // Add New Opportunity
            createNewOpportunity (props.token, props.siteId, client.id, opportunityName)
                .then (r => {
                    if ('id' && 'createdBy' in r) {
                        // Fill out the opportunity
                        setOpportunity (r.id, new Date ());
                        createNewFile (props.token, props.siteId, opportunity.content.id, `$properties.xml`, opportunity)
                            .then (r => {
                                if ('id' in r) {
                                    props.notify (`The opportunity was added successfully !`,
                                        'success')
                                    props.updateOpportunities ()
                                    props.reload()
                                    sleep (800).then (() => {
                                        props.closeDrawer ();
                                    })
                                } else if ('error' in r) {
                                    props.notify (r.error.message,
                                        'error')
                                } else {
                                    props.notify (`An error has occurred !`,
                                        'error')
                                }
                            })
                    } else if ('error' in r) {
                        props.notify (r.error.message,
                            'error')
                    } else {
                        props.notify (`An error has occurred !`,
                            'error')
                    }
                    setLoading (false);
                })
        }
    }

    let createClient = (clientName) => {
        setLoading (true);
        createNewClient (props.token, props.siteId, props.salesDriveId, clientName)
            .then (r => {
                if ('id' in r) {
                    hidePopup ();
                    props.notify (`The client was added successfully !`,
                        'success')
                    props.updateClients ()
                } else if ('error' in r) {
                    props.notify (r.error.message,
                        'error')
                } else {
                    props.notify (`An error has occurred !`,
                        'error')
                }
                setLoading (false);
            })
    }

    let awkwardCharacters = `"*:<>?/|\\`;
    let colsSizing = !isEditMode && {l: 3, c: 8};

    return (
        <Aux>
            { !isEditMode && <div className="language-select">
                <LanguageSelect defaultLanguage={ props.defaultLanguage.label }
                                actionHandler={ (language) => props.changeLanguage (language) }/>
            </div> }
            <h1 className={ classes.drawerTitle }> { props.element ? props.element.name : translation (props.lang, "Create New Opportunity") } </h1>
            <div className={ classes.formFields }>
                <Form onSubmit={ e => {
                    e.preventDefault ()
                } }>

                    <FormField
                        dict={ props.dict }
                        addToDictionary={ props.addToDictionary }
                        lang={ props.lang }
                        label={ translation (props.lang, "Opportunity") } isRequired value={ opportunityName }
                        disabled={ isEditMode }
                        onChange={ (v) => setOpportunityName (v) }
                        isInvalid={ containsAnyOf (opportunityName, awkwardCharacters) }
                        feedback={ `${ translation(props.lang, "Enter a name that does not contain any of these characters")} " * : < > ? / | \\` }
                        colsSizing={ colsSizing }/>

                    <FormField
                        label={ "Client" } isRequired value={ JSON.stringify (client) }
                        disabled={ isEditMode }
                        onChange={ (v) => setClient (JSON.parse (v)) } as={ "select" }
                        colsSizing={ colsSizing }
                        extraCol={ !isEditMode && <Aux> <Icon
                            classIcon="fas fa-plus-circle"
                            color="#464775"
                            size="30"
                            label="Add New Client"
                            action={ (e) => launchPopup (e, "Add New Client") }/>
                            <AddClient
                                lang={ props.lang }
                                dict={ props.dict }
                                addToDictionary={ props.addToDictionary }
                                hidePopup={ hidePopup }
                                popupLauncher={ popupLauncher }
                                isOpenPopup={ _.isEqual (openPopup, "Add New Client") }
                                onSubmit={ (clientName) => createClient (clientName) }/> </Aux> }>

                        <option
                            value={ JSON.stringify (clientEntity) }>
                            ---- { translation (props.lang, "Select") } ----
                        </option>
                        { props.clients.map ((c, i) => {
                            return (<option key={ i } value={ JSON.stringify (c) }>{ c.name }</option>)
                        }) }
                    </FormField>

                    <FormField
                        label={ translation (props.lang, "Manager") } isRequired value={ JSON.stringify (manager) }
                        onChange={ (v) => setManager (JSON.parse (v)) } as={ "select" }
                        colsSizing={ colsSizing }>

                        <option value={ JSON.stringify (managerEntity) }>
                            ---- { translation (props.lang, "Select") } ----
                        </option>
                        { props.salesMembers.map ((m, i) => {
                            return (<option key={ i } value={ JSON.stringify (m) }>{ m.email }</option>)
                        }) }
                    </FormField>

                    <FormField
                        label={ translation (props.lang, "Deadline") } value={ deadline }
                        onChange={ (v) => setDeadline (v) } type={ "date" }
                        colsSizing={ colsSizing }/>

                </Form>
            </div>

            <ButtonsStrip
                maxWidth={ {maxWidth: '50%'} }
                lang={ props.lang }
                buttons={ [
                    {
                        label: "Save",
                        variant: "success",
                        isDisabled: areEmptyRequiredFields () || containsAnyOf (opportunityName, awkwardCharacters) || loading,
                        isVisible: true,
                        actionHandler: () => saveOpportunity ()
                    },
                    {
                        label: "Close",
                        variant: "danger",
                        isVisible: true,
                        actionHandler: (e) => handleCloseDrawer (e),
                        popup: {
                            anchorEl: popupLauncher,
                            show: (_.isEqual (openPopup, "Close")),
                            onClose: () => hidePopup (),
                            onSubmit: () => discardChanges (),
                            title: "Delete changes ?",
                            body: "This will delete the unsaved changes you just made"
                        }
                    }
                ] }
                isOpenOpportunityDrawer={props.isOpenOpportunityDrawer }
            />
        </Aux>
    )
};

export default Element;

let containsAnyOf = (text, unwanted) => {
    return text.split ("").some (c => unwanted.indexOf (c) !== -1);
}